export default __webpack_public_path__ + "static/brain_transparent-23bff46981df3b707c288c0fb60a80f6.png";